import { useAppConstantsContext } from '@/context/AppConstants';
import { List, Stack, Text } from '@/theme/index';

export const SalvageRecordsHowItWorks = () => {
  const {
    data: { brandName },
  } = useAppConstantsContext();

  const infoList = [
    'The name, address, and contact information for the reporting entity.',
    'VIN.',
    'Date the automobile was obtained.',
    'Name of the individual or entity from whom the automobile was obtained (this information will be available to law enforcement and appropriate governmental agencies ONLY).',
    'A statement of whether the automobile was crushed or disposed of, or offered for sale.',
    'Whether the vehicle is intended for export out of the United States.',
  ];

  return (
    <Stack
      direction="column"
      fontSize="0.9rem"
      spacing={1}
      color={(theme) => theme.palette.grey[800]}
      data-testid="how-it-works-salvage-records"
    >
      <Text variant="body2" component="span">
        {brandName} reports include NMVTIS salvage data. NMVTIS is the only
        publicly available system in the United States to which all insurance
        carriers, auto recyclers, junk yards, and salvage yards, are required,
        under federal law, to report to on a regular basis. They are required to
        provide NMVTIS with the following information on each vehicle received
        into inventory every month:
      </Text>
      <List sx={{ listStyleType: 'disc', paddingLeft: 4 }}>
        {infoList.map((info, index) => (
          <Text variant="body2" component="li" key={index}>
            {info}
          </Text>
        ))}
      </List>
      <Text variant="body2" component="span">
        Auto recyclers, and junk and salvage yards, that handle fewer than five
        vehicles per year that are determined to be salvage (including total
        loss) or junk are not required to report to NMVTIS consistent with
        federal legal requirements for automobile dealers.
      </Text>
      <Text variant="body2" component="span">
        A vehicle that has a salvage or total loss history has had severe
        damage. Salvage and total loss history help consumers avoid purchasing a
        potentially unsafe vehicle.
      </Text>
    </Stack>
  );
};
